import componentInitializer from "@/frontend/utils/componentInitializer"
import { normalizeOrigin } from "@/frontend/utils/normalizeOrigin"

componentInitializer(() => {
  let el = document.querySelector("#product_origin")
  if (el) {
    const { origin, listingId } = el.dataset
    if (listingId) {
      sessionStorage.setItem(`origin_${listingId}`, normalizeOrigin(origin))
    }
  }
})
